import style from "./Header.module.css";
import logo from "../../assets/images/logo.png";
import { Link, useMatch, useResolvedPath,useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

function CustomLink({ children, to, ...props }) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <>
      <Link className={`test ${match ? style.active : ""}`} to={to} {...props}>
        {children}
      </Link>
    </>
  );
}
export default function Main() {
  const location = useLocation();
  const navigate = useNavigate(); // 引入路由导航钩子

  // 重构滚动锚点逻辑：先跳转到首页，再滚动到search锚点
  const scrollToAnchor = () => {
    // 如果当前已经在首页，直接滚动
    if (location.pathname === "/") {
      scrollToSearchElement();
    } else {
      // 如果不在首页，先跳转到首页，跳转完成后再滚动
      // 1. 先跳转到首页（同步执行，无返回值）
      navigate("/", { replace: true });
      // 2. 延迟执行滚动（确保首页DOM已渲染）
      setTimeout(() => {
        scrollToSearchElement();
      }, 100);
    }
  };

  // 抽离滚动逻辑为独立函数，便于复用
  const scrollToSearchElement = () => {
    const anchorElement = document.getElementById("search");
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  // 额外优化：如果首页通过锚点链接进入（如 /#search），也自动滚动
  useEffect(() => {
    if (location.pathname === "/" && window.location.hash === "#search") {
      scrollToSearchElement();
      // 清除hash，避免重复触发
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, [location]);

  return (
    <>
      <div
        className={`${location.pathname == "/" ? style.type1 : style.type2} ${
          style.header
        } `}
      >
        <div className={style.headerc}>
          <Link to="/">
            <img src={logo} className={`${style.logo}`} />
          </Link>
          <div className={style.nav}>
            <CustomLink to="/">首页</CustomLink>
            <CustomLink to="/about">关于我们</CustomLink>
            <CustomLink to="/recommend">推荐服务</CustomLink>
            <CustomLink to="/company">公司动态</CustomLink>
            <CustomLink to="/industry">行业资讯</CustomLink>
            <a href="https://tzb.release.zgjmdbw.com/" target="_blank">
              保函办理
            </a>
            <a onClick={scrollToAnchor}>保函查询</a>
            <CustomLink to="/contact">联系我们</CustomLink>
          </div>
        </div>
      </div>
      {location.pathname != "/" && <div className={style.headerspan}></div>}
    </>
  );
}
